import Vue from 'vue'
import './js/vue-ls/index' // 本地存储
import App from './App.vue'
import router from './router'
import http from './api'
import moment from 'moment'
import share from './common/share'
import storeData from './store/index'

import Vant from 'vant'
import { Toast } from 'vant'
import 'vant/lib/index.css'
import { Lazyload, Swipe, SwipeItem, Dialog, ImagePreview, Popup, Cell, CellGroup } from 'vant'
import Vconsole from 'vconsole'
import env from './config/env'

//开发环境调试工具显示
console.log('config',env.env); 
if (env.env === 'test') {
  new Vconsole()
}

Vue.prototype.$http = http
Vue.prototype.moment = moment
Vue.prototype.$share = share
Vue.prototype.$store = storeData
Vue.prototype.$Dialog = Dialog
Vue.prototype.$ImagePreview = ImagePreview

Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup)
Vue.use(Cell)
Vue.use(CellGroup)

Vue.prototype.$Toast = Toast
Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  to.meta.from = from.path
  next()
})
var store = {
  debug: true,
  state: {
    isInitWx: false,
    detail: {},
    isX: false,
  },
  async initwx(newValue) {
    console.log('初始化')
    this.state.isInitWx = newValue
    let reqUrl = location.href
    // const u = navigator.userAgent
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    // if (isiOS) {
    //   const url = location.href
    //   console.log('地址', url)
    //   if (url.indexOf('from') !== -1) {
    //     // const urlArr = url.split('?')
    //     const newUrl = url
    //       .replace('?from=groupmessage&isappinstalled=0', '')
    //       .replace('?from=timeline&isappinstalled=0', '')
    //       .replace('?from=singlemessage&isappinstalled=0', '')
    //     location.replace(newUrl)
    //   } else {
    //     reqUrl = `${location.origin}${location.pathname}`
    //   }
    //   if (location.href.indexOf('&reloaded') == -1) {
    //     location.href = location.href + '&reloaded'
    //     location.reload()
    //   }
    // }
    // const code = location.href.split('code=')[1]
    var ua= window.navigator.userAgent.toLowerCase();
    if( (ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork') ){
      console.log('企业微信')
      const page = encodeURIComponent(window.location.origin + window.location.pathname) 
      // console.log('正在授权')
      if (window.wx && window.wx.config) {
        // 获取企业微信授权
        const res = await http.post(`aocampaignsales/openapi/sale/agent/jsapi?agentid=${env.agentId}&url=${page}`)
          .catch(error => { 
            console.log('error',error)
          })
        // 获取应用授权
        const res2 = await http.post(`aocampaignsales/openapi/sale/agent-jsapi-ticket?agentid=${env.agentId}&url=${page}`)
          .catch(error => {
            console.log('error',error)
          })
        console.log('企业授权', res)
        console.log('应用授权', res2)
        if (res && res2) {
          const data = res.data
          const data2 = res2.data
          return new Promise(() => {
            window.wx.config({
              beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.appId, // 必填，企业微信的corpID
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
              jsApiList: ['getLocation','openLocation','onMenuShareAppMessage','onMenuShareTimeline','onMenuShareWechat'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
            })
            window.wx.ready(function () {
              window.wx.agentConfig({
                corpid: data2.appId, // 必填，企业微信的corpID
                agentid: env.agentId,
                timestamp: data2.timestamp, // 必填，生成签名的时间戳
                nonceStr: data2.nonceStr, // 必填，生成签名的随机串
                signature: data2.signature, // 必填，签名
                jsApiList: ['getLocation','openLocation','onMenuShareAppMessage','onMenuShareTimeline','onMenuShareWechat'], // 必填，需要使用的JS接口列表
                success: function () {
                },
                fail: function (resF) {
                  if (resF.errMsg.indexOf('function not exist') > -1) {
                    alert('版本过低请升级')
                  }
                }
              })
            })
          })
        } else{ 
          console.log('失败授权')
        }
      }
    } else if(ua.match(/micromessenger/i) == 'micromessenger'){
      http.get(`aocampaign/openapi/user/get-share-sign?url=${reqUrl}`).then((res) => {
        const data = res.data
        // alert(JSON.stringify(data))
        console.log('微信')
        if (window.wx) {
          window.wx.config({
            // debug: true,
            appId: data.appid, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            openTagList: ['wx-open-launch-weapp'],
            jsApiList: ['getLocation','openLocation','onMenuShareAppMessage', 'onMenuShareTimeline','updateAppMessageShareData','updateTimelineShareData','showOptionMenu','hideOptionMenu'], // 必填，需要使用的JS接口列表
          })
          window.wx.error(function(e) {
            console.log('config信息验证失败',JSON.stringify(e))
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          })
        }
      })
    }
  },
  setDetail(newValue) {
    if (this.debug) console.log('setData triggered with', newValue)
    this.state.detail = newValue
  },
  setMessageAction(newValue) {
    if (this.debug) console.log('setMessageAction triggered with', newValue)
    this.state.isX = newValue
  },
  clearMessageAction() {
    if (this.debug) console.log('clearMessageAction triggered')
    this.state.isX = ''
  },
}
// 使用&时，会遗漏第一个query参数
let arrUrl = window.location.href.split("&");
console.log('arrUrl：',arrUrl);
console.log('arrUrl[0]：', arrUrl[0].indexOf('?')>-1, arrUrl[0].split('?'));
if(arrUrl&&arrUrl.length>0&&arrUrl[1]&&arrUrl[1].length>0){
  let search={}
  // 为什么arrUrl[1]是code ？？？？？？
  let temp=arrUrl[1]
  let qar = temp.split('=')
  if (qar.length === 2) {
    search[qar[0]] = qar[1]
  }else{
    search[qar[0]] = null
  }
  if (search && search.code) {
    Vue.ss.set('ssCode', search.code)
    if(Vue.ss.get('pageUrl')){
      let baseUrl = arrUrl[0]
      if (baseUrl.indexOf('?') > -1 && baseUrl.split('?') && baseUrl.split('?').length) {
				baseUrl = baseUrl.split('?')[0]
			}
      let url=baseUrl+'?'+Vue.ss.get('pageUrl')
      window.location.href=url
    }else{
      // 看不懂，为什么要取arrUrl[2] ？？？？？
      if(arrUrl[2] &&arrUrl[2].length>0){
        let temp2=arrUrl[2]
        let qar2 = temp2.split('=')
        if(qar2.length===2){
        let url=arrUrl[0]+`?state=${qar2[1]}`
         window.location.href=url
        }
      }
    }
  }else{
    let baseUrl = arrUrl[0]
    if(Vue.ss.get('pageUrl')){
			if (baseUrl.indexOf('?') && baseUrl.split('?') && baseUrl.split('?').length) {
				baseUrl = baseUrl.split('?')[0]
			}
			let url = baseUrl + '?' + Vue.ss.get('pageUrl')
      window.location.href=url
    }
  }
}


new Vue({
  el: '#app',
  router,
  data: {
    store,
  },
  template: '<App/>',
  components: { App },
})
